var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92426 6.13708C9.15858 6.37139 9.15858 6.75129 8.92426 6.9856L5.10589 10.804C4.87157 11.0383 4.49167 11.0383 4.25736 10.804C4.02304 10.5697 4.02304 10.1898 4.25736 9.95545L7.65147 6.56134L4.25736 3.16723C4.02304 2.93291 4.02304 2.55301 4.25736 2.3187C4.49167 2.08438 4.87157 2.08438 5.10589 2.3187L8.92426 6.13708ZM1 7.16134C0.668629 7.16134 0.4 6.89271 0.4 6.56134C0.4 6.22997 0.668629 5.96134 1 5.96134V7.16134ZM8.5 7.16134H1V5.96134H8.5V7.16134Z",
    fill: "#ACBED2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.56134V11.5613",
    stroke: "#ACBED2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseOut);
export default __webpack_public_path__ + "static/media/CollapseOut.7dde082cbef370c3ce3c5e7cd082f6aa.svg";
export { ForwardRef as ReactComponent };